import { RG_TYPE } from "@project-rouge/rg-core";
import { Vector3toV3, getPivot } from "@project-rouge/rg-three";
import { getApartmentEntryPosition } from "./index77.js";
import { getCoreEntryPosition } from "./index78.js";
function getEntranceDistance(unit) {
  let entryPos = [0, 0, 0];
  if (unit.type === RG_TYPE.Apartment)
    entryPos = getApartmentEntryPosition(unit);
  else if (unit.type === RG_TYPE.Core)
    entryPos = getCoreEntryPosition(unit);
  else
    Vector3toV3(getPivot([0.5, 0, 0], unit));
  const entryDistance = (1 - unit.anchor[0]) * unit.size[0] - entryPos[0];
  return entryDistance;
}
export {
  getEntranceDistance
};
//# sourceMappingURL=index249.js.map
